import React from 'react';
import { Container } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import MainForm from './MainForm';

const ProjectCreateContainer = () => {
  return (
    <>
      <Container fluid={true}>
        <Breadcrumbs justify='end' pageTitle='Project List' parent='Project' title='Project List' />
        <MainForm />
      </Container>
    </>
  );
};

export default ProjectCreateContainer;
